// ─── 背景・テキスト ─────────────────────────────────

export const BG_GRADIENT =
  "linear-gradient(135deg, #0a0e1a 0%, #0d1224 40%, #1a1e3a 100%)";

export const TEXT_PRIMARY = "#f0f4ff";
export const TEXT_SECONDARY = "#b0c4e8";

// ─── 都市カラー ─────────────────────────────────────

/** 3 都市以下で使用する固定パレット (cyan, amber, magenta) */
export const CITY_COLORS = ["#00e5ff", "#ffb300", "#e040fb"] as const;

/**
 * 都市のインデックスと総数から色を返す。
 * - total ≤ 3: 固定パレットから取得
 * - total > 3: HSL 色相を均等分割して自動生成
 */
export function getCityColor(index: number, total: number): string {
  if (total <= 3) {
    return CITY_COLORS[index % CITY_COLORS.length];
  }
  const hue = (index * 360) / total;
  return `hsl(${hue}, 80%, 60%)`;
}

/**
 * 都市名の配列からカラーマップを生成する。
 */
export function getCityColorMap(cities: string[]): Map<string, string> {
  const map = new Map<string, string>();
  for (let i = 0; i < cities.length; i++) {
    map.set(cities[i], getCityColor(i, cities.length));
  }
  return map;
}
